import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toHref (event) {
    event.preventDefault()
    const href = event.currentTarget.dataset.href
    window.location.href = href
  }

  stopPropagation (event) {
    event.stopPropagation()
  }

  get header () {
    const element = document.head.querySelector('meta[name="csrf-token"]')

    return {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': element.content,
    }
  }

  batchDownload () {
    const elements = document.querySelectorAll('input[type="checkbox"]:checked')
    const invoiceIds = Array.from(elements).map(target => target.value)

    if (invoiceIds.length === 0) {
      return alert('チェックボックスがチェックされていません。')
    }

    fetch('/api/admin/company/invoices/generate_zip_jobs', {
      method: 'POST',
      headers: this.header,
      body: JSON.stringify({ invoiceIds }),
    })
      .then(response => {
        if (response.ok) return response.json()
        throw new Error(response.statusText)
      })
      .then(data => {
        alert('請求書PDFの生成処理を開始しました。')
        console.log('ok')
      })
      .catch(error => {
        alert('請求書PDFの生成処理に失敗しました。')
        console.log(error)
      })
  }
}
